import React from 'react';
import { CheckCircle } from 'lucide-react';
interface PurchaseNotificationProps {
  name: string;
  city: string;
  isVisible: boolean;
}
export function PurchaseNotification({
  name,
  city,
  isVisible
}: PurchaseNotificationProps) {
  return <div className={`fixed bottom-4 left-4 z-50 transform transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-10">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-3 border-l-4 border-green-500 max-w-xs md:max-w-sm" data-id="element-11">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-12">
          <CheckCircle className="w-5 h-5 text-green-600" data-id="element-13" />
        </div>
        <div data-id="element-14">
          <p className="text-sm font-medium text-gray-900" data-id="element-15">
            <span className="font-bold" data-id="element-16">{name}</span> de{' '}
            <span className="font-bold" data-id="element-17">{city}</span>
          </p>
          <p className="text-xs text-gray-600" data-id="element-18">
            acaba de comprar Control Eléctrico
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-19">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}